// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jc-0";
export var fileCarousel = "_jc-2";
export var removeFileButton = "_jc-1";